export const toolBarTabs = [
  'Prime Brokers',
  'Fixing Sources',
  'Cuts',
  'Currency Pairs',
  'Users'
]
